import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from '../../config/TranslationProvider';
import { generateRoute, useRoutes } from '../../routing/RouteProvider';
import { formatISO, startOfToday } from 'date-fns';

const TagList = ({ tags, routeName = 'events' }) => {
    const routes = useRoutes();
    const filterPath = tagTitle => {
        const filter = {};
        filter['tags'] = [tagTitle];

        if (routeName !== 'locations') {
            filter['end_date_from'] = formatISO(startOfToday());
        }

        return generateRoute(routes, routeName, { filter });
    };

    return (
        <div className="widget atbd_widget widget-card">
            <div className="atbd_widget_title">
                <h4><span className="la la-tags" />&nbsp;<Translate value="tags" /></h4>
            </div>
            <div className="widget-body atbdp-widget-tags">
                <ul className="list-unstyled">
                    {tags.map(({ id, title }) => (
                        <li key={id} title={title}>
                            <Link to={filterPath(title)} aria-label={'filter-for-tag-' + title}>{title}</Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TagList;
